import styles from './sign-in-code-form.module.scss';
import { Button, FormikTextInputField } from '@spotted-zebra-uk/ui-components';
import { Formik, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useMemo } from 'react';

const initialValues = { signInCode: '' };
//Sign in code has to be 6-digit number
const MIN_CODE_NUMBER = 100000;
const MAX_CODE_NUMBER = 999999;

type SignInCodeFormProps = {
  submitting: boolean;
  onSignInCodeSubmit: (signInCode: string) => void;
};

export const SignInCodeForm = ({
  submitting,
  onSignInCodeSubmit,
}: SignInCodeFormProps) => {
  const { t } = useTranslation();

  const validationForm = useMemo(() => {
    return yup.object().shape({
      signInCode: yup
        .number()
        .typeError(t('twoFactorAuthentication.signInCodeInvalid'))
        .required(t('twoFactorAuthentication.signInCodeInvalid'))
        .min(MIN_CODE_NUMBER, t('twoFactorAuthentication.signInCodeInvalid'))
        .max(MAX_CODE_NUMBER, t('twoFactorAuthentication.signInCodeInvalid')),
    });
  }, []);

  const onSubmit = (values: { signInCode: string }) => {
    onSignInCodeSubmit(values.signInCode);
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationForm}
    >
      {({ handleSubmit }) => (
        <form onSubmit={e => e.preventDefault()}>
          <FormikTextInputField
            id="signInCode"
            label={t('twoFactorAuthentication.signInCode')}
            placeholder={t('twoFactorAuthentication.signInCode')}
            useFormikField={useField}
          />
          <Button
            onClick={() => handleSubmit()}
            fullWidth
            className={styles.submitButton}
            disabled={submitting}
          >
            {t('common.submit')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
